import { ONE_MINUTE } from '@datadog/js-core/time'
import { setTimeout } from '@datadog/js-core/util'

export type EventRateLimiter = ReturnType<typeof createEventRateLimiter>

// Limit the maximum number of actions, errors and logs per minutes
const EVENT_RATE_LIMIT = 3000

export function createEventRateLimiter(
  eventType: string,
  onLimitReached: (message: string) => void,
  limit = EVENT_RATE_LIMIT
) {
  let eventCount = 0
  let allowNextEvent = false

  return {
    isLimitReached() {
      if (eventCount === 0) {
        setTimeout(() => {
          eventCount = 0
        }, ONE_MINUTE)
      }

      eventCount += 1
      if (eventCount <= limit || allowNextEvent) {
        allowNextEvent = false
        return false
      }

      if (eventCount === limit + 1) {
        allowNextEvent = true
        try {
          onLimitReached(`Reached max number of ${eventType}s by minute: ${limit}`)
        } finally {
          allowNextEvent = false
        }
      }

      return true
    },
  }
}
